import React from "react";
import { Base } from "../RootLayout";
import * as Assets from "../../utils/svg_assets";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import useCheckConnection from "../../hooks/useCheckConnection";

const NoInternetConnection = () => {
  const navigate = useNavigate();
  const { isOnline } = useCheckConnection();

  return (
    <Base>
      <div className="page-config">
        <img
          src={Assets.iconWifiOff}
          className="w-icon-no-internet"
          alt="Not Internet Connection"
        />
        <div className="font-bold fs-22">No Connection Found</div>
        <p className="fs-15">Please check your network connection</p>
        <Button
          variant="danger"
          className="btn-login mt-3"
          style={{ maxWidth: "400px" }}
          onClick={() => navigate(-1)}
          disabled={isOnline ? false : true}
        >
          {isOnline ? "Refresh" : "Back"}
        </Button>
      </div>
    </Base>
  );
};

export default NoInternetConnection;
